import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import TeacherReport from "./TeacherReport";
import NonTeachingStaffReport from "./NonTeachingStaffReport";

const StaffReport = () => {
  const [searchParams] = useSearchParams();
  const typeFromURL = searchParams.get("type");

  const [selectedForm, setSelectedForm] = useState("teacher");

  useEffect(() => {
    if (typeFromURL === "nonTeaching") {
      setSelectedForm("nonTeaching");
    } else {
      setSelectedForm("teacher");
    }
  }, [typeFromURL]);

  return (
    <div className="py-6">
      <div className="mb-8 flex justify-center space-x-4">
        <button
          className={`px-5 py-2.5 text-lg font-medium rounded-lg transition-all duration-500 ease-in-out transform ${
            selectedForm === "teacher"
              ? "bg-blue-800 text-white shadow-lg scale-105"
              : "bg-gray-200 text-gray-800 hover:bg-gray-300 hover:shadow-md"
          }`}
          onClick={() => setSelectedForm("teacher")}
        >
          Teacher Report
        </button>

        <button
          className={`px-5 py-2.5 text-lg font-medium rounded-lg transition-all duration-500 ease-in-out transform ${
            selectedForm === "nonTeaching"
              ? "bg-blue-800 text-white shadow-lg scale-105"
              : "bg-gray-200 text-gray-800 hover:bg-gray-300 hover:shadow-md"
          }`}
          onClick={() => setSelectedForm("nonTeaching")}
        >
          Non-Teaching Staff Report
        </button>
      </div>

      {selectedForm === "teacher" && <TeacherReport />}
      {selectedForm === "nonTeaching" && <NonTeachingStaffReport />}
    </div>
  );
};

export default StaffReport;
